import React from 'react';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'El Despertar Neuro-Sensorial',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777384111/ChatGPT_Image_28_abr_2026_10_47_17_glcspk.webp'
}, {
  label: 'Tomo 2',
  sublabel: 'El Conquistador de Espacios',
  image: 'https://cdn.magicpatterns.com/uploads/mpoNoFqiLVsZb6MpZMSZ4e/Gemini_Generated_Image_5usuts5usuts5usu.webp'
}, {
  label: 'Tomo 3',
  sublabel: 'La Revolución del Lenguaje',
  image: 'https://cdn.magicpatterns.com/uploads/kk1dCjqrtMhs8coHUy6XWh/Captura_de_pantalla_2026-04-23_141342.webp'
}, {
  label: 'Tomo 4',
  sublabel: 'Autonomía y Conexión Sináptica',
  image: 'https://cdn.magicpatterns.com/uploads/dPVkj5rFnJr3cpRGZNtdMY/Gemini_Generated_Image_qdzsphqdzsphqdzs.webp'
}, {
  label: 'Tomo 5',
  sublabel: 'Pensamiento Lógico y Socialización',
  image: 'https://cdn.magicpatterns.com/uploads/nBMnsuhXiGoJiGyC2EGUz9/Gemini_Generated_Image_aktn6aaktn6aaktn.webp'
}, {
  label: 'Tomo 6',
  sublabel: 'El Niño Pre-escolar',
  image: 'https://cdn.magicpatterns.com/uploads/3MhrduCfiVcMDgZWUYYz29/Gemini_Generated_Image_3v30fd3v30fd3v30.jpg'
}];
const features = ['✅ Actividades listas mes a mes para cada etapa del desarrollo', '✅ Semáforo de alertas neurológicas para detectar señales a tiempo', '✅ Protocolos de estimulación motor, lenguaje, cognitivo y emocional', '✅ Checklists de hitos + registros de progreso para seguir la evolución'];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(253,244,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(243,232,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-257">
      <div className="mx-auto max-w-4xl text-center" data-id="element-258">

        {/* ── BADGE ── */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-purple-700 border border-purple-400/40 bg-purple-700/5 rounded-full px-4 py-1.5" data-id="element-259">
          🏆 El sistema de estimulación temprana más completo para madres de Argentina
        </div>

        {/* ── SUBTITLE ── */}
        <h3 className="text-xl font-bold m-0 mb-4" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }} data-id="element-260">
          MEGAPACK ESTIMULACIÓN TEMPRANA PARA MADRES
        </h3>

        {/* ── DESCRIPTION ── */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-261">
          360 páginas · Actividades mes a mes por área de desarrollo · Semáforo
          de alertas neurológicas · Protocolos de estimulación motor, lenguaje,
          cognitivo y emocional · Checklists de hitos · Registros de progreso ·
          Listo para usar hoy.
        </p>

        {/* ── TOMES GRID ── */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-262">
          <div className="grid grid-cols-6 gap-3" data-id="element-263">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-264">
                {/* Card con imagen */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-purple-200/50" data-id="element-265">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-266" />
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-267">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-268">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-269">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* ── BADGE INFERIOR ── */}
          <div className="mt-6 flex justify-center" data-id="element-270">
            <div className="whitespace-nowrap text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" style={{
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
          }} data-id="element-271">
              6 TOMOS COMPLETOS · 360 PÁGINAS
            </div>
          </div>
        </div>

        {/* ── FEATURE TAGS ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-272">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 border rounded-xl px-4 py-3 text-left" style={{
          background: 'rgba(124,58,237,0.04)',
          borderColor: 'rgba(168,85,247,0.25)'
        }} data-id="element-273">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center" style={{
            background: 'rgba(124,58,237,0.12)'
          }} data-id="element-274">
                <svg className="w-3 h-3" style={{
              color: '#7c3aed'
            }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-275">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-276" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-277">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>

      </div>
    </section>;
}